import { createSlice } from "@reduxjs/toolkit";
import { Filters } from "../types/activities";

const filtersInitialState: Filters = {
    activityType: [],
    region: [],
    groupModel: [],
    availablePeriod: [],
    category: '',
    difficultyLevel: [],
    other: [],
    activityDuration: [],
    search: '',
}

// Il cambiamento di filtersObject provoca la ripetizione della chiamata per le activities in AllActivities.jsx
const filtersSlice = createSlice({
    name: 'filters',
    initialState: filtersInitialState,
    reducers: {
        setNewFilters: (state, action) => {
            const newFilters = action.payload;
            return {
                ...state,
                ...newFilters
            }
        },
        emptyFilters: (state) => {
            return filtersInitialState;
        }
    }
})

export const { setNewFilters, emptyFilters } = filtersSlice.actions;
export default filtersSlice.reducer;